import { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import { getCep, usuarioSchema, checkCpf } from "../../../helpers";
import { useDispatch, useSelector } from "react-redux";
import * as types from "../../../store/types/cadastro";
import { v4 as uuidv4 } from "uuid";
import contrate from "../../../assets/contrate.png";
import ModalAceiteContrato from "./modalAceiteContrato";
import { cadastroSite } from "../../../store/actions/cadastro";
import DadosPessoais from "./dadosPessoais";
import { useLocation, useNavigate } from "react-router-dom";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function PersonData({ proximo }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const query = useQuery();
  const { cadastro_site, loading, dataCompleta, pessoaPoliticamenteExposta } =
    useSelector((state) => state.cadastro);
  const [data, setData] = useState(cadastro_site);
  const [modal, setModal] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [largura, setLargura] = useState();
  const [pessoaPolitica, setPessoaPoliticamenteExposta] = useState(
    pessoaPoliticamenteExposta
  );
  const [confirmar, setConfirmar] = useState(false);
  const [confirmarEmail, setConfirmarEmail] = useState(false);
  const [messageError, setMessageError] = useState("");

  useEffect(() => {
    const larg = window.screen.width;
    setLargura(larg);
    window.scrollTo(0, 0);
  }, []);

  const IdVendedorQuery = query.get("seller");
  const IdEmpresa = query.get("company");
  const IdPlano = query.get("plan");

  function ShowPassword() {
    setShowPass(showPass ? false : true);
  }

  async function SetCep(e, setFieldValue, validateField) {
    const Cep = await getCep(e.target.value);
    Cep.logradouro && setFieldValue("endereco", Cep.logradouro);
    Cep.bairro && setFieldValue("bairro", Cep.bairro);
    Cep.localidade && setFieldValue("cidade", Cep.localidade);
    Cep.uf && setFieldValue("uf", Cep.uf);
    validateField("cep");
    validateField("endereco");
    validateField("bairro");
    validateField("cidade");
  }

  const [cpfValidacao, setCpfValidado] = useState(true);

  async function ValidarCpf(cpf) {
    const cpfValidado = await checkCpf(cpf.target.value);
    setCpfValidado(cpfValidado.valid);
  }

  const next = proximo;

  const [dataN, setDataN] = useState({
    diaNascimento: dataCompleta.diaNascimento,
    mesNascimento: dataCompleta.mesNascimento,
    anoNascimento: dataCompleta.anoNascimento,
  });

  const propostaId = uuidv4();

  const onSubmit = async (values) => {
    await dispatch([
      {
        type: types.DADOS_PESSOAIS_SITE,
        payload: {
          ...values,
          dataNascimento: `${dataN.anoNascimento}-${dataN.mesNascimento}-${dataN.diaNascimento}`,
          propostaId: propostaId,
        },
      },
      {
        type: types.PESSOA_POLITICAMENTE_EXPOSTA,
        payload: Boolean(pessoaPolitica),
      },
      {
        type: types.DADOS_DATA_NASCIMENTO,
        payload: {
          diaNascimento: dataN.diaNascimento,
          mesNascimento: dataN.mesNascimento,
          anoNascimento: dataN.anoNascimento,
        },
      },
    ]);
    setModal(true);
  };

  async function ConfirmarContratacao() {
    try {
      const dataResponse = await cadastroSite(
        {
          ...cadastro_site,
          vendedorId: IdVendedorQuery ? Number(IdVendedorQuery) : null,
          // empresaId: IdEmpresa ? Number(IdEmpresa) : null
        },
        navigate
      );
    } catch (e) {
      setModal(false);
      dispatch({ type: types.CADASTRO_LOADING, payload: false });
      setMessageError(e);
    }
  }

  return (
    <div style={{ height: "100%", overflowY: "scroll" }}>
      <Grid container spacing={1}>
        <Grid item sm={5} xs={12}>
          <div
            style={{
              backgroundColor: "#947cfe",
              width: "100%",
              marginRight: "2em",
              padding: "2em",
              height: "100%",
            }}
          >
            <h1
              style={{
                color: "#fff",
                fontSize: 30,
                fontWeight: "normal",
              }}
            >
              Fynd, a nova forma
              <br /> de cuidar de você
              <br /> e a sua família!
            </h1>
            <img src={contrate} alt="Contrate" style={{ width: "90%" }} />
          </div>
        </Grid>

        <DadosPessoais
          data={data}
          onSubmit={onSubmit}
          usuarioSchema={usuarioSchema}
          ShowPassword={ShowPassword}
          dataN={dataN}
          setDataN={setDataN}
          largura={largura}
          cpfValidacao={cpfValidacao}
          pessoaPolitica={pessoaPolitica}
          showPass={showPass}
          SetCep={SetCep}
          ValidarCpf={ValidarCpf}
          messageError={messageError}
          setMessageError={setMessageError}
        />
      </Grid>
      <ModalAceiteContrato
        confirmacao={() => ConfirmarContratacao()}
        openModal={modal}
        closeModal={() => setModal(false)}
        confirmar={confirmar}
        setConfirmar={setConfirmar}
        confirmarEmail={confirmarEmail}
        setConfirmarEmail={setConfirmarEmail}
        largura={largura}
        loading={loading}
      />
    </div>
  );
}

export default PersonData;
